<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>Video</h1>
        <paragrafo
          >Confira abaixo o processo de compra exemplificado em vídeo, onde
          serão mostrados os seguintes passos:</paragrafo
        >
        <li>Seleção de um produto;</li>
        <li>
          Adição de outros três ingressos ao carrinho (já aviam 2 ingressos no
          carrinho);
        </li>
        <li>Exclusão de alguns itens no ícone de lixeira;</li>
        <li>Escolha da opção de pagamento em dinheiro;</li>
        <li>
          Preenchimento do valor entregue pelo cliente, assim realizando o
          cálculo do troco.
        </li>
        <paragrafo>
          <v-row justify="center"
            ><div v-for="video in videos" :key="video.title">
              <video class="video-js" controls preload="auto" width="300">
                <source v-bind:src="video.src" type="video/webm" />
              </video></div></v-row
        ></paragrafo>
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "outrasOpt",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    // imagem: () => import("@/docs/components/infos/imagem.vue"),
    // negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      videos: [
        {
          src: "/pos/imagensPOS/video.webm",
        },
      ],
    };
  },
};
</script>
